<template>
  <div class="importHistory">
    <h2>Lịch sử import khách hàng</h2>

    <div class="d-flex mb-2 flex-wrap align-items-center">
      <span class="mr-2 font-bold">Loại khách hàng</span>

      <b-form-select
        v-model="customerType"
        :options="customerTypeOptions"
        style="max-width:260px"
        @change="resetAndFetch"
      />

      <b-button
        class="ml-2"
        variant="outline-success"
        @click="resetAndFetch"
      >
        <i class="fa fa-refresh mr-1"></i>
        Đặt lại
      </b-button>
    </div>

    <b-table
      bordered
      hover
      head-variant="dark"
      :items="dataTable"
      :fields="fields"
      responsive
    >
      <template #cell(action)="data">
        <a href="#" @click.prevent="openDetail(data.item.id)">
          Xem chi tiết
        </a>
      </template>
    </b-table>

    <div v-if="dataTable.length === 0" class="text-center text-muted mt-3">
      Không có dữ liệu
    </div>

    <div class="d-flex justify-content-between mt-3 flex-wrap">
      <small class="text-muted">
        Hiển thị
        {{ (currentPage - 1) * perPage + 1 }}
        –
        {{ Math.min(currentPage * perPage, totalElements) }}
        /
        {{ totalElements }}
        bản ghi
      </small>

      <div class="d-flex">
        <b-form-select
          size="sm"
          v-model="selectedPerPage"
          :options="optionsPages"
          class="mr-2"
          style="max-width:100px"
          @change="changePerPage"
        />
        <b-pagination
          v-model="currentPage"
          :total-rows="totalElements"
          :per-page="perPage"
          size="sm"
          @change="changePage"
        />
      </div>
    </div>

    <b-modal ref="detailModal" hide-footer>
      <template #modal-header>
        <h5>Chi tiết import</h5>
      </template>

      <div v-if="detail">
        <p><b>ID:</b> {{ detail.id }}</p>
        <p><b>Tên file:</b> {{ detail.file_name }}</p>
        <p>
          <b>Loại khách hàng:</b>
          {{ detail.customer_type === 'new'
            ? 'Khách hàng mới'
            : 'Khách đã tạo đơn' }}
        </p>
        <p><b>Số dòng import thành công:</b> {{ detail.success_rows }}</p>
        <p>
          <b>Thời gian import:</b>
          {{ formatDate(detail.created_at) }}
        </p>
        <p><b>Người import (ID):</b> {{ detail.created_user }}</p>
      </div>

      <div v-else class="text-muted">
        Đang tải dữ liệu...
      </div>

      <div class="text-right mt-3">
        <b-button size="sm" variant="danger" @click="closeDetail">
          Đóng
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import apiClient from '@/axios'

export default {
  data() {
    return {
      customerType: '',
      customerTypeOptions: [
        { value: '', text: 'Tất cả' },
        { value: 'new', text: 'Khách hàng mới' },
        { value: 'ordered', text: 'Khách đã tạo đơn' }
      ],

      dataTable: [],
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'file_name', label: 'Tên file' },
        {
          key: 'customer_type',
          label: 'Loại dữ liệu  ',
          formatter: v =>
            v === 'new' ? 'Khách hàng mới' : 'Khách đã tạo đơn'
        },
        { key: 'success_rows', label: 'Import thành công' },
        {
          key: 'created_at',
          label: 'Thời gian',
          formatter: v => this.formatDate(v)
        },
        { key: 'action', label: 'Chi tiết' }
      ],

      currentPage: 1,
      perPage: this.$perPage || 20,
      selectedPerPage: this.$perPage || 20,
      totalElements: 0,
      optionsPages: this.$paginationPages || [
        { value: 10, text: '10' },
        { value: 20, text: '20' },
        { value: 50, text: '50' }
      ],

      detail: null
    }
  },

  mounted() {
    this.fetchLogs()
  },

  methods: {
   async fetchLogs() {
    const res = await apiClient.get('/api/v1/import-customer-logs', {
      params: {
        customerType: this.customerType || undefined,
        perPage: this.perPage,
        currentPage: this.currentPage
      }
    })

    const metadata = res?.data?.metadata

    if (metadata) {
      this.dataTable = metadata.data || []
      this.totalElements = metadata.total || 0
    } else {
      this.dataTable = []
      this.totalElements = 0
    }
  },

    resetAndFetch() {
      this.currentPage = 1
      this.fetchLogs()
    },

    changePage(page) {
      this.currentPage = page
      this.fetchLogs()
    },

    changePerPage() {
      this.perPage = this.selectedPerPage
      this.currentPage = 1
      this.fetchLogs()
    },

   async openDetail(id) {
    this.detail = null
    this.$refs.detailModal.show()

    try {
      const res = await apiClient.get(`/api/v1/import-customer-logs/${id}`)
      this.detail = res?.data?.metadata || null

      if (!this.detail) {
        this.$bvToast.toast('Không lấy được chi tiết import', {
          variant: 'warning',
          solid: true
        })
      }
    } catch (e) {
      this.detail = null
      this.$bvToast.toast('Lỗi khi lấy chi tiết import', {
        variant: 'danger',
        solid: true
      })
    }
  },

    closeDetail() {
      this.$refs.detailModal.hide()
      this.detail = null
    },

    formatDate(value) {
      if (!value) return ''
      return this.$moment
        ? this.$moment(value).format('DD/MM/YYYY HH:mm')
        : new Date(value).toLocaleString()
    }
  }
}
</script>

<style scoped>
.importHistory a {
  color: #0d6efd;
  cursor: pointer;
}
</style>
